import { render, staticRenderFns } from "./ReminderPlanDelete.vue?vue&type=template&id=af7feda8&"
import script from "./ReminderPlanDelete.vue?vue&type=script&lang=js&"
export * from "./ReminderPlanDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports